var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgNumber = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentcolor",
  viewBox: "0 0 16 16",
  ref: ref
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M9.58 6.39q.301 0 .463.194t.162.486q0 .358-.282.66-.184.194-.81.641-.72.515-.914.974a2.2 2.2 0 0 0-.212.905h3.151v-.797H9.13a1 1 0 0 1 .21-.25q.127-.108.466-.35l.362-.257q.457-.323.657-.587a1.45 1.45 0 0 0 .305-.907q0-.667-.432-1.07-.432-.405-1.161-.406-.924 0-1.286.688-.19.362-.212.95h.879q.015-.388.101-.566.15-.307.562-.307zm-3.762 3.86h.926V5.648h-.752q0 .06-.035.184a.8.8 0 0 1-.177.33.85.85 0 0 1-.445.241 4 4 0 0 1-.6.057v.616h1.083z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "M4 2.25A1.75 1.75 0 0 0 2.25 4v8c0 .966.784 1.75 1.75 1.75h8A1.75 1.75 0 0 0 13.75 12V4A1.75 1.75 0 0 0 12 2.25zM3.75 4A.25.25 0 0 1 4 3.75h8a.25.25 0 0 1 .25.25v8a.25.25 0 0 1-.25.25H4a.25.25 0 0 1-.25-.25z",
  clipRule: "evenodd"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgNumber);
export default ForwardRef;